export default __webpack_public_path__ + "static/media/sindicato.784b7b3f.svg";